import { HomeworksUIProvider } from "./HomeworksUIContext";
import { HomeworksCard } from "./HomeworksCard";

export function HomeworksPage({ history }) {
  const homeworksUIEvents = {
    openHomeworkDetailPage: (id) => {
      history.push(`/odevler/detay/${id}`);
    }
  };

  return (
    <HomeworksUIProvider homeworksUIEvents={homeworksUIEvents}>
      <HomeworksCard />
    </HomeworksUIProvider>
 );
}